import React, { useEffect, useState } from "react";
import classes from "./../useradmin.module.scss";

import { Button, Card } from "../../../Utils";
import {
  Avatar,
  DeleteShower,
  DropDown,
  InstitutionRow,
} from "../../../Components";

import axiosInstance from "../../../axiosInstance";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchInstitutionList,
  setDocProperty,
} from "../../../Store/Actions/InstitutionAction";
import { fetchMoreBadgesList } from "./../../../Store/Actions/BadgeAction";
import SuspendedActionBtn from "./SuspendedActionBtn";

const UserCard = (props) => {
  const dispatch = useDispatch();
  const { badgeList } = useSelector(({ badgeReducer }) => badgeReducer);
  const [loading, setLoading] = useState(false);
  const { docId, suspensionStatus } = props;

  const deleteHandler = async () => {
    try {
      const res = await axiosInstance.post(`/admin/deleteUser`, {
        role: "institutions",
        uid: docId,
      });
      toast.success("Institution Deleted Successfully.");
      dispatch(fetchInstitutionList());
    } catch (err) {
      console.log(err.response);
    }
  };

  const suspensionHandler = async () => {
    try {
      setLoading(true);
      const res = await axiosInstance.post(`/admin/suspendUser`, {
        uid: docId,
        role: "institution",
      });
      const { data } = res.data;
      toast.success(
        `Institution ${data.suspensionStatus ? "Suspended" : "Unsuspended"}`
      );
      dispatch(
        setDocProperty(docId, "suspensionStatus", data.suspensionStatus)
      );
    } catch (err) {
      console.log(err, err.response);
      toast.success(`Please try another time.`);
    } finally {
      setLoading(false);
    }
  };
  const badgeHandler = async (badgeSrc) => {
    try {
      setLoading(true);
      const res = await axiosInstance.post(`/admin/grantBadge`, {
        uid: docId,
        role: "institution",
        src: badgeSrc,
      });
      const { data } = res.data;
      toast.success(`Badge Assigned Successfully.`);
      dispatch(setDocProperty(docId, "badge", badgeSrc));
    } catch (err) {
      console.log(err, err.response);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card
      className={`flex ${classes.card} ${
        suspensionStatus && classes.card__suspended
      }`}
    >
      <InstitutionRow {...props} varient="LIST" />
      <div className={classes.card__actions}>
        <Button onClick={props.onEditClick}>Edit</Button>
        {!loading && (
          <div style={{ width: "180px" }}>
            <DropDown
              optionsList={badgeList}
              placeholder="Assign Badge"
              customItemRender={(value) => {
                return (
                  <li key={value.docId} onClick={() => badgeHandler(value.src)}>
                    <Avatar src={value.src} varient="none" size={34} />
                    <span style={{ marginLeft: "6px" }}>{value.badgeName}</span>
                  </li>
                );
              }}
              loadMore={() => dispatch(fetchMoreBadgesList())}
            />
          </div>
        )}
        <SuspendedActionBtn
          suspensionStatus={suspensionStatus}
          suspensionHandler={suspensionHandler}
          loading={loading}
        />
        <DeleteShower onClick={deleteHandler} />
      </div>
    </Card>
  );
};

export default UserCard;
